/* The mood tiles close the page: the bottom spacing dubai's boards give their
   last section. `section.` outranks the Section module's own padding whatever
   the CSS order. */
section.last {
  padding-bottom: 52px;
}

@media (min-width: 1024px) {
  section.last {
    padding-bottom: 80px;
  }
}
